var _g, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPricetag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#00B8F1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.199.75h18.462a2.462 2.462 0 012.462 2.462v11.076a2.462 2.462 0 01-2.462 2.462H9.199L.749 8.787 9.199.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.615 8.75a2 2 0 114 0 2 2 0 01-4 0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.586 6.272h-2.367V5.88q0-.627-.083-.82-.082-.194-.351-.194-.217 0-.325.167-.109.167-.109.501 0 .557.223.78.217.222 1.277.867.903.545 1.23.835.329.29.555.82.225.53.225 1.321 0 1.266-.61 1.987-.609.72-1.827.89v.89h-1.09v-.92q-.95-.093-1.658-.729-.71-.635-.71-2.217v-.463h2.368v.58q0 .955.073 1.186.073.232.354.232.24 0 .358-.161.117-.162.117-.478 0-.797-.111-1.14-.112-.342-.762-.747-1.084-.68-1.474-.999-.39-.319-.673-.899-.285-.58-.285-1.313 0-1.06.601-1.664.6-.603 1.802-.744v-.756h1.09v.756q1.095.14 1.64.736.545.594.545 1.643 0 .147-.023.445z",
    fill: "#FFF"
  })));
}

export default SvgIconPricetag;